<template>
  <div class="home">
    <Home msg="Welcome to Your Vue.js App"/>
  	<div class="slider-container">
  	    <Slider />
  	</div>
    <SignUp />
    <div >
      <p>Copyright Spinning House Ltd. 2019 &nbsp; &nbsp; - &nbsp; &nbsp; Design by <a href="https://menacingmedia.com/" target="_blank">Menacing Media</a></p>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Home from '@/components/Home.vue'
import Slider from '@/components/Slider.vue'
import SignUp from '@/components/SignUp.vue'

export default {
  name: 'home',
  components: {
    Home,
    Slider,
    SignUp
  }
}
</script>

<style>
  .slider-container {
    padding: 100px 0;
  }

  @media only screen and (max-width: 800px) {
    .slider-container {
      padding: 0;
    }
  }
</style>
